import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
// import "./Layout.css";
import Dashboard from "../../Pages/Private/Dashboard/Dashboard";
import PublicFooter from "../../Components/PublicFooter/PublicFooter";
import PublicHeader from "../../Components/PublicHeader/PublicHeader";
import { Style } from "./Layout.css";
import Sidebar from "../../Components/Sidebar/Sidebar";
import UserListing from "../../Components/User Management Flow/Listing-Page/UserListing";
const Layout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  // Function to toggle sidebar
  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };

    handleResize(); // Check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="layout d-flex">
      <Sidebar isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
      <div className={`main-contnt d-flex flex-column`}>
        <PublicHeader toggleSidebar={toggleSidebar} />
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
